import { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    justifyContent: 'flex-end',
});
export const content: TRuleWithTheme = () => ({
    width: '100%',
});
